import { render, staticRenderFns } from "./TheCalendar.vue?vue&type=template&id=44801218&"
import script from "./TheCalendar.vue?vue&type=script&lang=js&"
export * from "./TheCalendar.vue?vue&type=script&lang=js&"
import style0 from "./TheCalendar.vue?vue&type=style&index=0&id=44801218&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports